import {ArticleStatistiques} from 'api-types/tolede';
import {useLivraisonsPossiblesContext} from 'ff-common';
import {useHalState} from '@synako/haligator';
import {useClient} from '@/haligator-factory';

type StatParLivraison = ArticleStatistiques['stats_par_livraison'][number];

/**
 * Hook : indique si un article est déjà commandé pour la date de livraison sélectionnée
 */
export function useArticleDejaCommande(code_article: string | undefined): {
  statsDejaCommande: StatParLivraison[];
  isDejaCommande: boolean;
  date_de_livraison: string;
} {
  const client = useClient();
  const {date_de_livraison} = useLivraisonsPossiblesContext();
  const {state: commandeStatsState} = useHalState(
    date_de_livraison
      ? client.follow('commande_statistiques', {date_de_livraison})
      : undefined,
  );

  const articlesDejaCommandes = (commandeStatsState?.data.par_article ??
    []) as ArticleStatistiques[];
  const articleDejaCommande = code_article
    ? articlesDejaCommandes.find((a) => a.code_article === code_article)
    : undefined;
  const statsDejaCommande = articleDejaCommande?.stats_par_livraison ?? [];

  return {
    statsDejaCommande,
    isDejaCommande: statsDejaCommande.length > 0,
    date_de_livraison,
  };
}
